import { Link } from 'react-router-dom';

export default function CustomAILogo({
  to,
  height = 36,
  style = {},
  className = '',
}) {
  const img = (
    <img
      src="/custum-ai-logo.svg"
      alt="custum.ai"
      style={{
        display: 'block',
        objectFit: 'contain',
        height: `${height}px`,
        width: 'auto',
        ...style,
      }}
      className={className}
    />
  );

  if (to) {
    return (
      <Link to={to} style={{ display: 'inline-flex', textDecoration: 'none' }}>
        {img}
      </Link>
    );
  }

  return img;
}
